import { render, staticRenderFns } from "./MobileRecord.vue?vue&type=template&id=0031e6d0&scoped=true&"
import script from "./MobileRecord.vue?vue&type=script&lang=js&"
export * from "./MobileRecord.vue?vue&type=script&lang=js&"
import style0 from "./MobileRecord.vue?vue&type=style&index=0&id=0031e6d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031e6d0",
  null
  
)

export default component.exports